/* Pair independent rich-text sections with their bundle's server-formatted summary.
   Shopify supplies current products and presentment-currency prices. */
(() => {
  if (window.Eurus.loadedScript.has('bundle-summary.js')) return;
  window.Eurus.loadedScript.add('bundle-summary.js');

  const refresh = excludedSection => {
    const summaries = new Map();
    document.querySelectorAll('[data-bundle-summary-data]').forEach(source => {
      if (excludedSection?.contains(source)) return;
      const anchor = source.dataset.bundleSummaryAnchor;
      if (anchor) summaries.set(anchor, source.textContent.trim());
    });
    document.querySelectorAll('[data-bundle-summary-source]').forEach(target => {
      const paragraph = target.querySelector('[data-bundle-summary-text]');
      if (!paragraph) return;
      const anchor = target.dataset.bundleSummarySource;
      const text = summaries.has(anchor) ? summaries.get(anchor) : target.dataset.bundleSummaryFallback;
      paragraph.textContent = text;
      target.hidden = text === '';
      const disclosure = target.closest('[data-description-disclosure]');
      if (disclosure) disclosure.hidden = text === '';
    });
    document.dispatchEvent(new CustomEvent('description-disclosure:refresh'));
  };

  document.addEventListener('shopify:section:load', () => refresh());
  document.addEventListener('shopify:section:unload', event => refresh(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => refresh(), { once: true });
  else refresh();
})();
